import {Directive, ElementRef, OnInit} from "@angular/core";
import {BusService} from "../services/bus.service";
declare var $: any;


@Directive({
  selector: "[nvPreloader]"
})
export class NvPreloaderDirective implements OnInit {
  constructor(private element: ElementRef,
              private busService: BusService) {
  }


  ngOnInit(): void {
    this.busService
      .onPreloaderIsVisible
      .subscribe((isVisible: boolean): void => this.updateState(isVisible));
  }

  private updateState(visible: boolean): void {
    if (visible) {
      this.show();
    } else {
      this.hide();
    }
  }


  show() {
    $(this.element.nativeElement)
      .addClass("page-loading");
  }


  hide() {
    $(this.element.nativeElement)
      .removeClass("page-loading");
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/directives/preloader.directive.ts